<form [formGroup]="physicianSelectionForm">
  @if (label) {
    <div class="mb-2">
      <span class="font-semibold">{{ label }}</span>
    </div>
  }
  <p-listbox
    [options]="availablePhysicians"
    formControlName="selectedPhysician"
    (onClick)="physicianListBoxClick($event)"
    [listStyle]="{'max-height':'200px', 'height':'200px', 'width':'100%'}"
    [style]="{'border':'0px', 'width':'100%'}">
  </p-listbox>
</form>
